import React from 'react';

function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-surface-950 p-6 flex items-center justify-center">
      <div className="text-center">
        <div className="relative flex items-center justify-center w-20 h-20 mx-auto"> {/* Added flex and mx-auto */}
          <div className="w-20 h-20 border-4 border-accent-dim rounded-full"></div>
          <div className="w-20 h-20 border-4 border-accent border-t-transparent rounded-full animate-spin absolute"></div>
        </div>
        <p className="text-gray-300 mt-4 text-lg font-medium">Loading premium models...</p>
        <p className="text-gray-500 text-sm mt-2">Please wait a moment</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;